module.exports = __webpack_public_path__ + "static/media/expense-icon.a3d2a4d1.png";